/* jp-article.js — builds an "On this page" table of contents from the article body's <h2>
   headings (client-side, since RTE content has no server-side heading list) and assigns stable
   ids for deep-linking. Progressive enhancement: no JS -> the TOC stays hidden and the article
   is fully readable. If there are fewer than the configured minimum headings, the TOC removes
   itself. No frameworks; guarded against double-execution + re-run on shopify:section:load. */
(() => {
  if (window.__jpArticleInit) return;
  window.__jpArticleInit = true;

  const slug = (s) =>
    String(s || '')
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .slice(0, 60);

  const build = (root) => {
    (root || document).querySelectorAll('[data-jp-toc]').forEach((toc) => {
      if (toc.dataset.jpBound) return;
      const content = document.querySelector(toc.dataset.jpTocSource || '.jp-article__content');
      if (!content) return;
      const heads = content.querySelectorAll('h2');
      const min = parseInt(toc.dataset.min, 10) || 3;
      if (heads.length < min) { toc.remove(); return; } // not enough headings to be useful
      toc.dataset.jpBound = '1';

      const seen = Object.create(null);
      const list = document.createElement('ol');
      list.className = 'jp-toc__list';
      heads.forEach((h, i) => {
        // fall back to a stable synthetic id when a heading is entirely non-Latin (kanji / accented -> empty slug)
        const base = h.id || slug(h.textContent) || ('section-' + (i + 1));
        let id = base;
        let n = 1;
        while (seen[id]) { id = base + '-' + (++n); } // guarantee uniqueness (closes suffix-vs-real-heading collisions)
        seen[id] = 1;
        h.id = id;
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = '#' + id;
        a.textContent = h.textContent;
        li.appendChild(a);
        list.appendChild(li);
      });
      if (!list.children.length) { toc.remove(); return; }
      (toc.querySelector('[data-jp-toc-body]') || toc).appendChild(list);
      toc.hidden = false; // reveal only once populated
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => build(document));
  else build(document);
  document.addEventListener('shopify:section:load', (e) => build(e.target));
})();
